import React, { useEffect, useState, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import { UserContext } from './UserContext';

const PurchaseRequisition = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  //console.log(token); return false;
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const singlePR = async (value) => {
    setSearchText(value);
      try {
        const response = await axios.get(baseUrl+'auth/getNewPR?user_id='+userId+'&prNumber='+value, config);
        const data = response.data?.data?.PR?.value || [];
        //console.log(data); return false;
        setPrData(data);
      } catch (error) {
        setPrData([]);
      } finally {
        setLoading(false);
      }
};

  const prTypeLabels = {
  "ZADM": "ZADM - Admin Purchases",
  "ZCAP": "ZCAP - Capital Purchase",
  "ZCON": "ZCON - Consignment Purchase",
  "ZDOM": "ZDOM - Domestic Purchase",
  "ZHSD": "ZHSD - HSD Purchase Order",
  "ZIMP": "ZIMP - Import Purchase",
  "ZINF": "ZINF - Infrastructure",
  "ZITP": "ZITP - IT Purchases",
  "ZOJR": "ZOJR - Outside Job Repairs",
  "ZSCP": "ZSCP - Sub Contracting Purc",
  "ZSER": "ZSER - Service Purchase",
  "ZSTO": "ZSTO - Not Use",
  "ZTRP": "ZTRP - Transport Service",
  "ZUB": "ZUB - STO pur req",
  "NB": "NB - Pur. Requisition",
  "NBS": "NBS - Pur. Requisition NBS"
};

  useEffect(() => {
      //console.log(userData);
    const fetchPRs = async () => {
      try {
        const response = await axios.get(baseUrl+'auth/getNewPR?user_id='+userId+'&prNumber='+0, config);
        const data = response.data?.data?.PR?.value || [];
        //console.log(data); return false;
        setPrData(data);
      } catch (error) {
        setPrData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPRs();
  }, []);

  useEffect(() => {
    const lower = searchText.toLowerCase();
    const filteredData = prData.filter(pr => {
      const prName = pr.PurchaseRequisition?.toLowerCase() || '';
      const prType = pr.PurchaseRequisitionType?.toLowerCase() || '';
      const desc = pr.PurReqnDescription?.toLowerCase() || '';
      return (
        prName.includes(lower) ||
        prType.includes(lower) ||
        desc.includes(lower)
      );
    });

    setFiltered(filteredData);
  }, [searchText, prData]);

  const columns = [
    {
      name: '#',
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: '60px',
    },
    { name: 'PR', selector: row => row.PurchaseRequisition, sortable: true },
    { name: 'PR Type', selector: row => prTypeLabels[row.PurchaseRequisitionType] 
                   ?? row.PurchaseRequisitionType },
    { name: 'Description', selector: row => row.PurReqnDescription },
    { name: 'Note', selector: row => row.PurReqnHeaderNote },
    {
      name: 'Actions',
      cell: row => (
        <button
          onClick={() => navigate(`/projectdetails/${row.PurchaseRequisition}`)}
          style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          View Details
        </button>
      )
    }
  ];

  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">Purchase Requisitions</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">Purchase Requisitions</li>
                </ol>
              </div>
            </div>
          </div>

        
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  
                  <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                    <input
                      type="text"
                      placeholder="Search.."
                      value={searchText}
                      onChange={(e) => singlePR(e.target.value)}
                      style={{
                        width: '30%',
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                        float: 'right'
                      }}
                    />
                  </div>

                  <DataTable
                    columns={columns}
                    data={filtered}
                    pagination
                    paginationServer={false}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={filtered.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={loading}
                    progressComponent={<div style={{color:"Green", fontSize: "1px"}}>.</div>}
                    highlightOnHover
                    persistTableHead
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar left as-is */}
        </div>
      </div>
    </>
  );
};

export default PurchaseRequisition;
